export const STATUS_MESSAGES = {
    // HTTP Status 相關
    401: 'Please log in.',
    403: 'Access denied.',
    404: 'Resource not found.',
    500: 'System error, please try again later.',
    502: 'System maintenance in progress.',
    504: 'Request timeout, please try again later.',
    
    // 業務邏輯相關
    '1001': 'Invalid plan',
    '1002': 'Invalid currency',
    '1003': 'Invalid trial-days',
    '1004': 'Invalid term-months',
    '1005': 'Seats cannot be less than subscriber amounts.',
    '1006': 'Failed to update because of ongoing or reserved subscriptions.',
    '1007': 'Deletion is not allowed.',
    'default': 'Something went wrong. Please try again.',
};  